import { Grid } from "@mui/material";
import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ConfigurationIcon } from "../../../assets/icons";
import { AppRoutes } from "../../../common/routesUtils";
import { col4 } from "../../../common/utils";
import { View } from "../../../components/layout/View";
import { ActionCard } from "../../../components/widgets/ActionCard";
import { PageType } from "../../../config/page.types";
import { useBreadcrumbs } from "../../../context/BreadcrumbsProvider";

const configurationCards = (
	t: TFunction,
	navigate: ReturnType<typeof useNavigate>,
	visitPage: (page: PageType) => void
) => [
	{
		icon: <ConfigurationIcon color="secondary" sx={{ fontSize: '48px' }} />,
		title: t("configuration/operating unit details"),
		description: t("configuration/manage your network"),
		onClick: () => {
			visitPage(PageType.DataCollectionConfigurationOperationalUnits);
			navigate(AppRoutes.DataCollectionConfigurationOperationalUnits);
		},
	},
];

export const Configuration = () => {
	const { t } = useTranslation("dataCollection");
	const navigate = useNavigate();
	const { visitPage } = useBreadcrumbs();

	return (
		<View pageType={PageType.DataCollectionConfiguration}>
			<Grid container spacing={2}>
				{configurationCards(t, navigate, visitPage).map((card, index) => (
					<Grid key={index} size={col4}>
						<ActionCard
							icon={card.icon}
							title={card.title}
							description={card.description}
							onClick={card.onClick}
						/>
					</Grid>
				))}
			</Grid>
		</View>
	);
};
